import React from 'react'
import './About.css'
import AboutCard from '../../About_card/About_card';
import img_one from '../../../assets/images/about_img1.png'
import img_two from '../../../assets/images/about_img2.png'
import img_three from '../../../assets/images/about_img3.jpg'
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../page-header/PageHeader';

const About = () => {
    const {t} = useTranslation()

    return (
        <>
            <Helmet>
                <title>{`${t("about_us")} - ${t("Ashgabat_International_Airport")}`}</title>
            </Helmet>
            <div className='About'>
                <PageHeader
                    title={t("about_us")}
                    breadCrumbItems={[
                        { label: t("home"), path: '/' },
                        { label: t("about_us"), path: '#' }
                    ]}
                />
                <div className='container py-12'>

                    <div className='flex mobileS:flex-col sm:flex-row gap-x-6'>
                        <div className="col">
                            <AboutCard navigate__='/about/1' width_='20rem' title={'about_pg_card_one'} content='about_pg_card_one_text' image={img_one} one={1} two={2} button_={true} />
                        </div>
                        <div className="col">
                            <AboutCard navigate__='/about/2' width_='20rem' title={'about_pg_card_two'} content='about_pg_card_two_text' image={img_two} one={1} two={2} button_={true} />
                        </div>
                        <div className="col">
                            <AboutCard navigate__='/news' width_='20rem' title={'news'} content='about_pg_card_three_text' image={img_three} one={1} two={2} button_={true} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About